<template>
  <div class="sc-table">
    <div class="title">
      <img src="@/assets/圆圈.png" alt />
      <div>省区供应商信息</div>
      <!-- <span class="update-date">最近更新时间：{{util.toDateString(new Date())}}</span> -->
    </div>

    <!-- <el-table
      :data="areaList"
      stripe
      style="width: 100%"
      header-cell-class-name="my-header-cell"
      header-row-class-name="my-header-row"
      row-class-name="my-row"
      cell-class-name="my-cell"
    >
      <el-table-column prop="area" label="战区"></el-table-column>
      <el-table-column prop="a" label="省区">
        <template slot-scope="scope">
          <span
            :class="
              hasData(scope.row.area, scope.row.a)
                ? 'province'
                : 'province-nodata'
            "
            @click="onProvinceSelect(scope.row.area, scope.row.a)"
            >{{ scope.row.a }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="b" label>
        <template slot-scope="scope">
          <span
            :class="
              hasData(scope.row.area, scope.row.b)
                ? 'province'
                : 'province-nodata'
            "
            @click="onProvinceSelect(scope.row.area, scope.row.b)"
            >{{ scope.row.b }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="c" label>
        <template slot-scope="scope">
          <span
            :class="
              hasData(scope.row.area, scope.row.c)
                ? 'province'
                : 'province-nodata'
            "
            @click="onProvinceSelect(scope.row.area, scope.row.c)"
            >{{ scope.row.c }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="d" label>
        <template slot-scope="scope">
          <span
            :class="
              hasData(scope.row.area, scope.row.d)
                ? 'province'
                : 'province-nodata'
            "
            @click="onProvinceSelect(scope.row.area, scope.row.d)"
            >{{ scope.row.d }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="e" label>
        <template slot-scope="scope">
          <span
            :class="
              hasData(scope.row.area, scope.row.e)
                ? 'province'
                : 'province-nodata'
            "
            @click="onProvinceSelect(scope.row.area, scope.row.e)"
            >{{ scope.row.e }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="f" label>
        <template slot-scope="scope">
          <span
            :class="
              hasData(scope.row.area, scope.row.f)
                ? 'province'
                : 'province-nodata'
            "
            @click="onProvinceSelect(scope.row.area, scope.row.f)"
            >{{ scope.row.f }}</span
          >
        </template>
      </el-table-column>
    </el-table> -->

    
    <el-table
      :data="dataListTable"
      stripe
      style="width: 100%"
      header-cell-class-name="my-header-cell"
      header-row-class-name="my-header-row"
      row-class-name="my-row"
      cell-class-name="my-cell"
    >
      <el-table-column v-for="(t,i) in tableColumnList" :key="i" :prop="'lable_'+i" :label="t" :width="(i===1||i===2)?'180':''">
        <template slot-scope="scope">
          <span
            :class="
              scope.row['value_'+i]
                ? 'province'
                : 'province-nodata'
            "
            @click="onProvinceSelect(scope.row.label_0, scope.row['label_'+i],i)"
            >{{getTableLabel(scope.row,i)}}</span
          >
          <!-- </br>
          <span
            :class="
              hasData(scope.row.label_0, scope.row['label_'+i])
                ? 'province'
                : 'province-nodata'
            "
            @click="onProvinceSelect(scope.row.label_0, scope.row['label_'+i])"
            >{{getTableLabel(scope.row,i)}}</span
          > -->
          <!-- <span
            :class="
              scope.row['value_'+i]
                ? 'province'
                : 'province-nodata'
            "
            @click="onProvinceSelect(scope.row.label_0, scope.row['label_'+i])"
            >{{ scope.row['label_'+i]?`${scope.row['label_'+i]}` :'' }}</span
          >
           </br>
          <span
            :class="
              scope.row['value_'+i]
                ? 'province'
                : 'province-nodata'
            "
            @click="onProvinceSelect(scope.row.label_0, scope.row['label_'+i])"
            >{{ scope.row['value_'+i]?`(${scope.row['value_'+i]})` :'' }}</span
          > -->
        </template>
      </el-table-column>
        </el-table>
    <el-dialog
      title="省区供应商信息"
      :visible.sync="dialogTableVisible"
      width="1000px"
    >
      <SupplyChainProvinceSupplierRanking
        :zone="zone"
        :province="province"
        @change="onProvincePageChange"
      />
    </el-dialog>
  </div>
</template>

<script>
import SupplyChainProvinceSupplierRanking from './SupplyChainProvinceSupplierRanking'

export default {
  name: 'ProductSalesData',
  components: {
    SupplyChainProvinceSupplierRanking
  },
  props: ['code'],
  data() {
    return {
      date: '',

      dialogTableVisible: false,

      zone: '',
      province: '',

      dataList: [],
      // areaList: [
      //   {
      //     area: '一区',
      //     a: '福建省',
      //     b: '江西省',
      //     c: '',
      //     d: '',
      //     e: '',
      //     f: ''
      //   },
      //   {
      //     area: '二区',
      //     a: '北京市',
      //     b: '天津市',
      //     c: '河北省',
      //     d: '辽宁省',
      //     e: '吉林省',
      //     f: '黑龙江'
      //   },
      //   {
      //     area: '三区',
      //     a: '上海市',
      //     b: '江苏省',
      //     c: '浙江省',
      //     d: '安徽省',
      //     e: '',
      //     f: ''
      //   },
      //   {
      //     area: '四区',
      //     a: '湖北省',
      //     b: '湖南省',
      //     c: '重庆市',
      //     d: '贵州省',
      //     e: '云南省',
      //     f: ''
      //   },
      //   {
      //     area: '五区',
      //     a: '四川省',
      //     b: '陕西省',
      //     c: '宁夏回族自治区',
      //     d: '',
      //     e: '',
      //     f: ''
      //   },
      //   {
      //     area: '六区',
      //     a: '广东省',
      //     b: '广西壮族自治区',
      //     c: '',
      //     d: '',
      //     e: '',
      //     f: ''
      //   },
      //   {
      //     area: '七区',
      //     a: '河北省',
      //     b: '山西省',
      //     c: '山东省',
      //     d: '河南省',
      //     e: '',
      //     f: ''
      //   }
      // ],
      // dataListTableBefore: [
      //   {
      //     label: '一区',
      //     value: 12,
      //     children: [
      //       { label: '福建省', value: 1 },
      //       { label: '福建省2', value: 1 }
      //     ]
      //   },
      //   {
      //     label: '二区',
      //     value: 12,
      //     children: [
      //       { label: '福建省', value: 1 },
      //       { label: '福建省2', value: 1 }
      //     ]
      //   },
      //   {
      //     label: '三区',
      //     value: 12,
      //     children: [
      //       { label: '福建省', value: 1 },
      //       { label: '福建省2', value: 1 }
      //     ]
      //   }
      // ],
      dataListTable:[],
      tableColumnList:['战区','省区','','','','','']
    }
  },
  created() {
    // this.init()
    this.getTableData()
  },
  methods: {
    getTableLabel(row,i){
      if(!row['label_'+i]){
        return ''
      }
      if(!row['value_'+i]){
        return row['label_'+i]
      }
      return `${row['label_'+i]}(${row['value_'+i]})`
    },
    // async init() {
    //   const response = await this.ajax.doPost({
    //     packageName: 'sc',
    //     className: 'scSupplierProvince',
    //     methodName: 'retrieve',
    //     params: {
    //       commodityCode: this.code,
    //       orderField: 'saleDate',
    //       orderDirection: 'desc',
    //       numPerPage: 1000
    //     }
    //   })

    //   this.dataList = response.results
    // },
    async getTableData() {
      const response = await this.ajax.doPost({
        packageName: 'sc',
        className: 'scSupplierProvince',
        methodName: 'getScSupplierProvincePercent',
        params: {
          commodityCode: this.code,
          orderField: 'saleDate',
          orderDirection: 'desc',
          numPerPage: 1000
        }
      })

      const resultValue = response
      resultValue&&this.combineDataList(resultValue)

      // console.log(this.dataListTable)
    },
    combineDataList(data) {
     this.dataListTable =  data.map((t,i)=>{
        // const obj = {}
        // t.children.forEach((cT,cI)=>{
        //   obj[`label_${cI+1}`] = cT.label
        //   obj[`value_${cI+1}`] = cT.value
        // })
        // const childObj = t.children.reduce((a,b,index)=>{
        //     Object.keys(b).forEach((k,kI)=>{
        //       a[`${k}_${index+1}`] = b[k]
        //     })
        //     return a
        // },{})

        // // console.log(childObj)
        return {
          label_0:t.label,
          value_0:t.value,
          ...t.children.reduce((a,b,index)=>{
            Object.keys(b).forEach((k,kI)=>{
              a[`${k}_${index+1}`] = b[k]
            })
            return a
        },{})
        }
      })
    },
    hasData(zone, province) {
      let result = false

      if (
        this.dataList.find((e) => e.zone === zone && e.province === province)
      ) {
        result = true
      }

      return result
    },
    onCurrentChange(e) {
      this.$emit('change', e)
    },
    onProvinceSelect(area, province,index) {
      if(index===0){
        return
      }
      this.dialogTableVisible = true

      this.zone = area

      this.province = province

      this.$emit('select', area, province)
    },
    onProvincePageChange(e) {
      this.$emit('change', this.zone, this.province, e)
    }
  }
}
</script>

<style lang="less">
.sc-table {
  .my-header-cell {
    background: #94a49b;
    color: white;

    font-size: 12px;
    padding: 0;
    height: 40px;
  }
  .my-row {
    // height: 40px;
  }
  .my-cell {
    padding: 0;
    height: 40px;
    font-size: 12px;
    // cursor: pointer;
  }
  .el-range-editor.el-input__inner {
    padding: 0 10px;
  }
  .el-button {
    padding: 9px 20px;
  }
  .el-button--primary {
    background-color: #1b994f;
    border-color: #1b994f;
  }
  .el-pagination {
    text-align: center;
    margin: 20px 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1b994f;
    border-color: #1b994f;
  }
}
</style>

<style lang="less" scoped>
.sc-table {
  width: 1100px;

  .title {
    margin: 20px 0;
    img {
      display: inline-block;
      width: 12px;
      height: 12px;

      margin-right: 10px;
    }
    div {
      display: inline-block;
      width: 200px;
      height: 28px;
      font-size: 20px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
    }
  }

  .subtitle {
    padding: 10px 0;
    .statistics-date {
      width: 56px;
      height: 22px;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;

      margin: 10px;
    }
    .button {
      margin-left: 10px;
    }
  }

  .province {
    cursor: pointer;
    color: #000;
  }

  .province-nodata {
    cursor: pointer;

    color: #999;
  }
}
</style>
